import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Качество`,
    content: {
      description: `
        <p>
          Квадратная шоколадка в фольге и обёртке с вашим дизайном. Размер шоколадки 3.5x3.5см. Толщина 3.5мм. Вес 5г.<br>
          На выбор обёртка из золотой или серебряной фольги.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
